var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQPauseSingle = function SvgQPauseSingle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.5,
    height: 12.81,
    x: 7.321,
    y: 5.595,
    rx: 1.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.5,
    height: 12.81,
    x: 14.722,
    y: 5.595,
    rx: 1.25
  })));
};
export { SvgQPauseSingle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB4PSI3LjMyMDgiIHk9IjUuNTk0NzMiIHdpZHRoPSIyLjUwMDQ5IiBoZWlnaHQ9IjEyLjgxMDUiIHJ4PSIxLjI1MDI0IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHJlY3QgeD0iMTQuNzIyMiIgeT0iNS41OTQ3MyIgd2lkdGg9IjIuNSIgaGVpZ2h0PSIxMi44MTA1IiByeD0iMS4yNSIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";